import { render, staticRenderFns } from "./DSPromotionsIcon.vue?vue&type=template&id=1db3c46e&scoped=true&"
import script from "./DSPromotionsIcon.vue?vue&type=script&lang=js&"
export * from "./DSPromotionsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db3c46e",
  null
  
)

export default component.exports